<template>
  <div class="index">
    <van-nav-bar title="发布病例" fixed left-arrow @click-left="$router.back()" style="z-index: 9999999" />
    <div class="head-bgc">
      <div class="head-bgc-title">淋巴瘤CAR-T治疗全程管理项目</div>
    </div>
    <!-- 内容 -->
    <div class="box">
      <div class="box-con">
        <!-- 步骤一 -->
        <div class="box-head">
          <div class="box-head-title">步骤一</div>
          <div class="box-head-img"><img src="@/assets/image/CARprocedure/left.png"></div>
          <div class="box-head-text">
            <div>请先完成调研问卷，才可以上传病例</div>
            <div style="color: #696BFF; margin-top: 5px;">
              (已填写{{ progressObj.survey_num }}次调研问卷)
            </div>
          </div>
        </div>
        <!-- 填写问卷 -->
        <div>
          <div class="box-one"
            v-if="this.progressObj.status == 0 || this.progressObj.status == 3 || this.progressObj.status == -1"
            @click="getverifytime">
            <img src="@/assets/image/CARprocedure/tian.png">
          </div>
          <div class="box-one"
            v-if="this.progressObj.status == 2 || this.progressObj.status == 1 || this.progressObj.status == 4"
            @click="$router.push({ path: '/lookList' })">
            <img src="@/assets/image/CARprocedure/cha.png">
          </div>
        </div>
        <!-- 步骤二 -->
        <div class="box-head">
          <div class="box-head-title">步骤二</div>
          <div class="box-head-img2"><img src="@/assets/image/CARprocedure/left.png"></div>
          <div class="box-head-text">
            <div>
              (每个用户一次只能上传一份病例)
            </div>
            <div style="color: #696BFF;margin-top: 5px;">
              (已上传{{ progressObj.case_num }}例病例)
            </div>
          </div>
        </div>
        <!-- 上传病例 -->
        <div class="box-form">
          <el-form :model="form" :rules="rules" ref="form" label-position="top">
            <el-form-item label="病例标题：" prop="title" style="width: 64.5%;">
              <el-input v-model="form.title" placeholder="请输入病例标题"></el-input>
            </el-form-item>
            <div>
              <el-form-item label="上传病例：" prop="case_url" class="case">
                <el-upload class="upload-demo" :limit="1" :action="action" :on-remove="handleRemove"
                  :before-remove="beforeRemove" :on-success="handleAvatarSuccess" multiple :file-list="fileList"
                  :before-upload="wenBeforeUpload" :on-progress="onProgressTest" :data="uploadData" accept=".ppt,.pptx">
                  <el-button size="small" type="primary" v-prevent="1500">上传病例资料</el-button>
                </el-upload>
                <a class="case-a" @click="mobandow">病例模板下载</a>
                <div class="case-text">说明：文件必须小于100M，文件上传类型请严格按照病例模板进行上传。</div>
              </el-form-item>
              <!-- <div>说明：再次点击【上传病例资料】，即可替换已上传的文件</div> -->
            </div>
            <div class="btn">
              <el-button style="width: 100px;height: 40px;font-size: 14px;border-radius: 6px;" type="primary"
                @click="submitForm('form')"
                :disabled="this.progressObj.status == 0 || this.progressObj.status == 3 || this.progressObj.status == -1">
                发布病例
              </el-button>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>   
<script>
export default {
  data() {
    return {
      progressObj: {},
      onimageShow: 0, //0未填写  1已填写  
      action: `https://up-z0.qiniup.com`,
      year: "",
      month: "",
      day: "",
      fileList: [],
      uploadData: { key: "", token: "" },
      form: { title: '', case_url: '', serial_num: '' },
      rules: {
        title: [
          { required: true, message: '请输入病例标题', trigger: 'blur' }
        ],
        case_url: [
          { required: true, message: '请上传病例', trigger: 'change' }
        ]
      }
    }
  },
  created() {
    this.getymdTime()
    // this.getonApi() 
    this.getCodeApi()
  },
  methods: {
    //获取年月日
    getymdTime() {
      const date = new Date();
      this.year = date.getFullYear(); // 获取当前年份，例如：2021
      this.month = date.getMonth() + 1; // 获取当前月份，注意需要加1，例如：9
      this.day = date.getDate(); // 获取当前日期，例如：22
    },
    //上传前   
    async wenBeforeUpload(file) {
      let suffix = this.getFileType(file.name) //获取文件后缀名
      let suffixArray = ['ppt', 'pptx'] //限制的文件类型，根据情况自己定义 
      if (suffixArray.indexOf(suffix) === -1) {
        // this.$message({
        //   message: '文件格式错误',
        //   type: 'error',
        //   duration: 2000  
        // })
        this.$toast("文件格式错误,请上传ppt格式");
      } else {
        //获取七牛云的token
        const { data: data } = await this.$http.get("system/qiniuToken");
        this.uploadData.token = data.data.token;
        this.uploadData.key = `medical/${this.year}-${this.month}-${this.day}-${file.uid}/${file.name}`;
        // return true;
        return suffixArray
      }
    },
    getFileType(name) {
      let startIndex = name.lastIndexOf('.')
      if (startIndex !== -1) {
        return name.slice(startIndex + 1).toLowerCase()
      } else {
        return ''
      }
    },
    //文件上传时
    onProgressTest(event, file, fileList) {
      let index = 0;
      fileList.forEach((v, i) => {
        if (v.uid === file.uid) {
          index = i;
        }
      });
      // 获取动态的进度
      let percent = parseInt(event.percent);
      this.$nextTick(() => {
        setTimeout(() => {
          if (percent >= 99) {
            // 当动态的进度超过99就获取dom 让值一直显示99直到上传成功
            let dom = document.getElementsByClassName("el-upload-list__item")[
              index
            ];
            let progressText = dom.getElementsByClassName("el-progress__text");
            if (progressText && progressText.length) {
              progressText[0].style.opacity = 0;
              progressText[0].innerText = "99%";
              progressText[0].style.opacity = 1;
            }
          }
        });
      });
    },
    //文件上传成功
    handleAvatarSuccess(res, file) {
      if (res.key != "" || res.key != undefined || res.key != null) {
        this.form.case_url = `https://resources.car-t.medcase.com.cn/${res.key}`;
        this.$toast("上传成功");
      } else {
        this.$toast("上传失败");
      }
    },
    //移除文件 提示
    beforeRemove(file, fileList) {
      // return this.$confirm(`确定移除 ${file.name}？`);
    },
    //移除后 
    handleRemove(file, fileList) {
      this.form.case_url = ''
    },
    //提交 
    submitForm(formName) {
      // this.$toast("项目名额已满，感谢参与！如有问题，请联系项目组。");
      // return 
      this.$refs[formName].validate((valid, object) => {
        if (valid) {
          this.getsubmitApi();
        } else {
          return false;
        }
      });
    },
    //获取提交接口 
    async getsubmitApi() {
      //通过可以发布     
      this.getCodeApi()
      if (this.progressObj.status != 4 && this.progressObj.status != 2) {
        const { data: data } = await this.$http.post(
          "medical/case",
          this.form
        );
        this.$toast(data.message);
        this.$router.push({ path: "/my/myCase" });
      } else {
        this.$toast(this.progressObj.status_text);
      }
    },
    //获取步骤一 
    async getonApi() {
      const { data: data } = await this.$http.get(
        "medical/survey",
      );
      if (data.data != null) {
        if (data.data.status == 0) {
          this.onimageShow = 0
          return
        }
        if (data.data.status == 1) {
          this.onimageShow = 1
          return
        }
      }
    },
    //病例模版下载
    mobandow() {
      window.open('https://resources.car-t.medcase.com.cn/template/淋巴瘤CAR-T治疗全程管理项目_病例模板.pptx');
    },
    //判断是否能发布 
    async getCodeApi() {
      const { data: data } = await this.$http.get("medical/progress");
      this.form.serial_num = data.data.serial_num
      this.progressObj = data.data
      if (data.data != null) {
        if (data.data.status == 0) {
          this.onimageShow = 0
          return
        }
        if (data.data.status == 1) {
          this.onimageShow = 1
          return
        }
      }
    },
    //征集时间  
    async getverifytime() {
      const { data: data } = await this.$http.get("/medical/verify-time");
      if (data.data.status == 0) {
        this.$router.push({ path: '/CARinlet' })
      } else {
        this.$toast(data.data.msg);
      }
    },
  }
} 
</script>  
<style scoped> .index {
   position: relative;
   top: 0;
   left: -15px;
   width: calc(100% + 30px);
   background: #F6F8FF;
 }

 .head-bgc {
   position: relative;
   width: 100%;
   height: 96px;
   background: url(@/assets/image/CARprocedure/bgc.png) no-repeat center 0px;
   background-position: center 0px;
   background-size: cover;
 }

 .head-bgc-title {
   color: #130F0F;
   font-weight: 600;
   font-size: 18px;
   margin: 0 auto;
   text-align: center;
   padding-top: 28px;
 }

 .box {
   position: relative;
   top: -20px;
   left: 0;
   background: #F6F8FF;
   border-radius: 15px 15px 0px 0px;
   overflow: hidden;
   transition: all .3s;
   /* box-shadow: 0px 0px 6px 1px #A4C4F1; */
   padding: 20px 15px;
   padding-bottom: 0;
 }

 .box-con {
   background-color: #fff;
   border-radius: 6px 6px 6px 6px;
   padding: 20px 12px;
 }

 .box-head {
   position: relative;
   display: flex;
   align-items: center;
 }

 .box-head-title {
   position: relative;
   margin-left: 10px;
   color: #000;
   font-size: 15px;
   font-weight: 600;
   z-index: 99;
   margin-right: 24px;
   width: 50px;
 }

 .box-head-img {
   position: absolute;
   top: 14px;
   left: 0;
   width: 62px;
   height: 12px;
 }


 .box-head-img2 {
   position: absolute;
   top: 23px;
   left: 0;
   width: 62px;
   height: 12px;
 }

 .box-head-text {
   position: relative;
   color: #8E8E8E;
   font-size: 13px;
 }

 .box-one {
   width: 321px;
   height: 122px;
   cursor: pointer;
   margin: 26px 0 47px;
 }

 .box-form {
   margin-top: 40px;
   position: relative;
 }

 .case {
   position: relative;
 }

 .case-a {
   color: #2567E9;
   position: absolute;
   top: 10px;
   left: 120px;
   text-decoration: underline;

 }

 .case-text {
   color: #8E8E8E;
   margin-top: 10px;
 }

 .btn {
   position: relative;
   display: flex;
   align-items: center;
   justify-content: center;
 }
</style>   